define('controllers/myreport/myreport-main.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('myReport', ['$scope', '$q', '$state', 'ngDialog', 'auiDialog', 'OpenOther','$location',
        function ($scope, $q, $state, ngDialog, auiDialog, OpenOther, $location) {
            /* 1. 局部变量声明 */
            var currentSubPage = '';
            var appList = [];
            var queryAPPFlag = false;
            //接口返回错误码
            var returnDesc = mainCons.mapWithDefaultConstant.reportReturnDesc;

            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                isShowMune: true,
                isShowFooter: true
            };

            init();

            function init() {
                var path = $location.path();
                if((path.indexOf('/myReport/payment') >= 0 )){
                    Model.isShowFooter = false;
                }
            }

            /**
             *
             * @param method 导出的方法。
             * @param param 导出的入参
             * @param judgeDownloadSuccess 校验导出是否成功
             */
            $scope.downloadReport = function (method, param, judgeDownloadSuccess, judgeDownloadFail) {
                method(param, 300000).then(function (resp) {
                    if (resp && (typeof judgeDownloadSuccess != 'function' || judgeDownloadSuccess(resp))) {
                        var handler = ngDialog.open({
                            template: 'pages/myreport/download.html',
                            className: '',
                            closeByEscape: false,
                            closeByDocument: false,
                            overlay: false,
                            controller: ['$scope', function ($scope) {
                                $scope.downloadURL = resp.downUrl || resp.downloadUrl || resp.url;
                                $scope.secret = resp.zipPassword || resp.password;
                                $scope.callback = function () {
                                    handler.close();
                                };
                                $scope.close = function () {
                                    handler.close()
                                };
                            }]
                        })
                    } else if (resp && resp.rtnCode && resp.rtnCode == 508) {
                        auiDialog.fail("导出失败", "请保持开始日期和结束日期在同一个自然月。");
                    } else if (resp && resp.rtnCode && resp.rtnCode == 509) {
                        auiDialog.fail("导出失败", "您本次下载数据量过大，请选择更小时间范围下载优惠券明细文档。");
                    } else if (resp && (!(resp.downUrl && resp.downloadUrl && resp.url) || resp.retCode == returnDesc.NO_DATA)) {
                        auiDialog.fail("导出失败", "暂无相关数据。");
                    } else {
                        auiDialog.fail("失败", "导出失败。");
                    }
                }).catch(function (resp) {
                    if (angular.isFunction(judgeDownloadFail)) {
                        judgeDownloadFail(resp);
                    } else {
                        auiDialog.fail("导出失败。");
                    }
                });
            };

            $scope.pagination = function (listData, pagination, noReverse) {
                if (listData && listData.length > 0) {
                    var list = angular.copy(listData);
                    if (!noReverse) {
                        list.reverse();
                    }
                    var startNumDownload = (pagination.currentPage - 1) * pagination.itemsPerPage;
                    if (startNumDownload > list.length) {
                        pagination.currentPage = 1;
                        startNumDownload = 0;
                    }
                    var endDownload = pagination.currentPage * pagination.itemsPerPage;
                    var listForShow = list.slice(startNumDownload, endDownload);
                    return {
                        pagination: pagination,
                        listForShow: listForShow
                    }
                } else {
                    pagination.totalCount = 0;
                    return {
                        pagination: pagination,
                        listForShow: []
                    }
                }
            };

            $scope.initAppList = function (pageType, serviceItem) {
                if (pageType != currentSubPage) {
                    appList = [];
                    queryAPPFlag = false;
                    currentSubPage = pageType;
                }
                return function () {
                    var defer = $q.defer();
                    if (queryAPPFlag) {
                        var time = window.setInterval(function () {
                            if (!queryAPPFlag) {
                                defer.resolve(appList);
                                window.clearInterval(time);
                            }
                        }, 10);
                    } else {
                        if (appList && appList.length > 0) {
                            defer.resolve(appList);
                        } else {
                            queryAPPFlag = true;
                            $scope.getProductListLoop(1, pageType, serviceItem).then(function (resp) {
                                appList = resp;
                                $scope.marketAppList = appList;
                                queryAPPFlag = false;
                                defer.resolve(appList);
                            });
                        }
                    }
                    return defer.promise;
                }
            };

            $scope.getProductListLoop = function (fromRecCount, pageType, serviceItems, defer, appList) {
                appList = appList || [];
                defer = defer || $q.defer();
                var request = {
                    serviceItem: serviceItems,

                };
                OpenOther.getReportAppList(request).then(function (data) {
                    if (data && data.returnCode == 200) {
                        var appInfoList = [];
                        var appLists = [];
                        data.appList.forEach(function (appInfo) {
                            if (!AUI.BaseJSUtil.contains(appLists, appInfo.appId)) {
                                if (pageType == 'appmarket' && serviceItems == 4) {
                                    changeId(appInfo);
                                }
                                appInfoList.push({
                                    prodID: appInfo.appId,
                                    prodName: appInfo.appName,
                                    packageName: appInfo.packageName
                                });
                                appLists.push(appInfo.appId);
                            }
                        });
                        appList = appList.concat(appInfoList);
                    }
                }).catch(function (data) {
                }).finally(function () {
                    defer.resolve(appList);
                });
                return defer.promise;
            };

            // 检查开始时间和结束时间是否为空,不为空返回true
            $scope.checkDate = checkDate;

            function checkDate(param, startTime, endTime) {
                startTime = startTime ? startTime : 'startTime';
                endTime = endTime ? endTime : 'endTime';

                if (!(AUI.BaseJSUtil.existy(param[startTime]) && AUI.BaseJSUtil.existy(param[endTime]))) {
                    return false;
                } else {
                    return true;
                }
            }

            function changeId(appInfo) {
                var appID = appInfo['appId'] + '';
                if (parseInt(appID, 10) === -1) {
                    return;
                }
                //转化为应用市场
                else if (appID.substring(0, 1) === 'C' || appID.substring(0, 2) === 'SC') {
                    return;
                } else {
                    appInfo['appId'] = 'C' + convertId(parseInt(appID, 10));
                }
            }

            function convertId(appID) {
                var result = appID;
                if (appID < 1000000) {
                    result = appID + 2000000;
                } else if (appID > 1000000 && appID < 10000000) {
                    result = appID - 1000000;
                }
                return result;
            }
        }]);
});

